import { PlayerSettingsDto } from "./player-setting.dto";
import { TacticPlayerDto } from "./tactic-player.dto";

export class TacticDto {
    squad: TacticPlayerDto[];
    playersSettings: PlayerSettingsDto[];
    number: number;
    wasteTime: number;
    offsideTrap: number;
    tough: number;
    playMaker: number;
    longPass: boolean;
    shortPass: boolean;
    middlePass: boolean;
    freeKick: number;
    cornerKick: number;
    pressingOwnHalf: boolean;
    pressingCenter: boolean;
    pressingOpponentHalf: boolean;
    mentality: number;
    leftFlank: number;
    rightFlank: number;
}